import {RxdbRepository} from "../../rxdb/rxdb.repository";
import {HttpClient} from "@angular/common/http";
import {OfflineCmcProtocolService} from "./offline-cmc-protocol.service";
import {OnlineCmcProtocolService} from "./online-cmc-protocol.service";
import {RxdbCmcProtocolRepository} from "../../rxdb/repositories/rxdb-cmc-protocol.repository";
import {TranslateService} from "@ngx-translate/core";
import {StandaloneModeService} from "../../standalone-mode.service";

export const cmcProtocolServiceFactory = (standaloneModeService: StandaloneModeService,rxdbRepository: RxdbRepository, httpClient: HttpClient, translateService: TranslateService) => {
    return standaloneModeService.isOffline() ? new OfflineCmcProtocolService(new RxdbCmcProtocolRepository(rxdbRepository), httpClient, translateService) : new OnlineCmcProtocolService(httpClient, translateService);
};